import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type DeleteRiskReductionMeasureDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
  hasLinkedHazards?: boolean
}

export function DeleteRiskReductionMeasureDialog({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  hasLinkedHazards = false,
}: DeleteRiskReductionMeasureDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const showBlockedState = hasLinkedHazards

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='sm:max-w-md' showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>
            {showBlockedState
              ? t(
                  'riskReductionMeasuresLibraryPage.deleteDialog.linkedHazardsBlockedTitle'
                )
              : t('riskReductionMeasuresLibraryPage.deleteDialog.title')}
          </DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {showBlockedState
            ? t(
                'riskReductionMeasuresLibraryPage.deleteDialog.linkedHazardsBlockedMessage'
              )
            : t('riskReductionMeasuresLibraryPage.deleteDialog.message')}
        </p>
        <DialogFooter>
          {showBlockedState ? (
            <Button onClick={onClose}>{t('common:actions.close')}</Button>
          ) : (
            <>
              <Button variant='outline' onClick={onClose} disabled={isDeleting}>
                {t('common:actions.cancel')}
              </Button>
              <Button
                variant='destructive'
                onClick={onConfirm}
                disabled={isDeleting}
              >
                {isDeleting
                  ? t('riskReductionMeasuresLibraryPage.deleteDialog.deleting')
                  : t('riskReductionMeasuresLibraryPage.deleteDialog.delete')}
              </Button>
            </>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
